<template>
  <v-layout fill-height column class="page-solution-intro">
    <div v-if="title !== '' && title !== undefined" class="solution-intro-title">{{ title }}</div>
    <div v-if="time !== '' && time !== undefined " class="solution-intro-time">[{{ time }}분]</div>
    <div class="solution-intro-subtitle">{{ smallTitle }}</div>
    <div v-if="description !== '' && description !== undefined"
         class="solution-intro-desc"
         v-html="description"
    ></div>
    <div class="solution-intro-content">
      <v-img v-if="photo !== '' && photo !== undefined && photo !== null"
             :src="$downUrl(photo)"
             aspect-ratio="2" contain class="mt-2 rounded-lg" />
      <video v-if="movie !== '' && movie !== undefined && movie !== null"
             ref="video"
             class="mt-2 rounded-lg"
             @click="videoPlay()" controls width="100%">
        <source :src="$downUrl(movie)" type="video/mp4">
      </video>
      <!-- <div class="text-center fs-14 gray--text">
          심호흡을 크게 3번 하면서<br>나의 몸과 마음을 느껴보세요.
      </div> -->
      <!-- 오디오 크롬에서 자동재생 이슈 -->
    </div>
  </v-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: undefined
    },
    time: {
      type: Number,
      default: null
    },
    smallTitle: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      default: undefined
    },
    movie: {
      type: Number,
      default: undefined
    },
    photo: {
      type: Number,
      default: undefined
    },
    sound: {
      type: Number,
      default: undefined
    }
  },
  mounted() {
    // console.log('photo : ', this.photo)
    // console.log('movie : ', this.movie)
  },
  methods: {
    videoPlay() {
      this.$refs.video.play();
    }
  }
}
</script>
